import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  BreadcrumbsDesignTokens,
} from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getBreadcrumbsTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): BreadcrumbsDesignTokens => ({
  separator: {
    color: theme.tokens.colors.icon.tertiary.value,
    'font-family': theme.typography.bodyMedium.fontFamily,
    'font-size': theme.typography.bodyMedium.fontSize,
    'font-weight': theme.typography.bodyMedium.fontWeight,
    'line-height': theme.typography.bodyMedium.lineHeight,
    'margin-left': px(theme.spacing.XS),
    'margin-right': px(theme.spacing.XS),
  },
  text: {
    'text-color': undefined,
    'font-weight': undefined,
    hover: {
      'text-color': undefined,
      'text-decoration': undefined,
    },
  },
  active: {
    'text-color': theme.tokens.colors.text.primary.value,
    'font-weight': undefined,
    'pointer-events': 'none',
    hover: {
      'text-color': undefined,
      'text-decoration': undefined,
    },
  },
  pile: {
    'icon-color': theme.tokens.colors.text.link.value,
    'menu-item-padding-right': px(theme.spacing.XS),
    padding: undefined,
    hover: {
      'icon-color': undefined,
    },
  },
});

export const getBreadcrumbsTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): BreadcrumbsDesignTokens => {
  const breadcrumb = tokens?.component?.breadcrumb;
  const fontWeight = breadcrumb?.['font-weight'];
  const textColor = breadcrumb?.['text-color'];

  const pileIconColor = tokens?.semantic?.['icon-color']?.control?.default;

  return {
    separator: {
      color: breadcrumb?.divider?.['background-color'],
      'font-family': fontFamily,
      'font-size': breadcrumb?.['font-size'],
      'font-weight': fontWeight?.default,
      'line-height': breadcrumb?.['line-height'],
      'margin-left': tokens?.generic?.spacing?.[12],
      'margin-right': tokens?.generic?.spacing?.[12],
    },
    text: {
      'text-color': textColor,
      'font-weight': fontWeight?.default,
      hover: {
        'text-color': textColor,
        'text-decoration': 'underline',
      },
    },
    active: {
      'text-color': textColor,
      'font-weight': fontWeight?.pressed,
      'pointer-events': undefined,
      hover: {
        'text-color': textColor,
        'text-decoration': 'underline',
      },
    },
    pile: {
      'icon-color': pileIconColor,
      'menu-item-padding-right': tokens?.generic?.spacing?.[4],
      padding: tokens?.generic?.spacing?.[8],
      hover: {
        'icon-color': pileIconColor,
      },
    },
  };
};
